import { useState, useEffect } from "react";
import { LineofBusiness } from "../models/LineofBusinessFilterData";

const useFilter = () => {
  const [selectedFilter, setSelectedFilter] = useState<LineofBusiness | null>(
    () => {
      return sessionStorage.getItem("selectedFilter") as LineofBusiness;
    }
  );

  useEffect(() => {
    if (selectedFilter) {
      sessionStorage.setItem("selectedFilter", selectedFilter);
    } else {
      sessionStorage.removeItem("selectedFilter");
    }
  }, [selectedFilter]);

  return { selectedFilter: selectedFilter ?? "electrical", setSelectedFilter };
};

export default useFilter;
